import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import styles from '../style.module.scss';
import cN from 'classnames';

interface I_Props {
    mobileHidden?: boolean;
}

const SellDate: React.FC<I_Props> = ({ mobileHidden }) => {
    const { GroupInfo } = useSelector((state: RootState) => state.groupReducer);

    return !mobileHidden && GroupInfo.Status === 9 && GroupInfo.SellStartDate ? (
        <div
            className={cN(
                styles['group-trip-info'],
                styles.sellDate,
                'group_trip_info',
                'sellDate'
            )}
        >
            <span className="icon ic-ln clock" />
            <span>{GroupInfo.SellStartDate} 開賣</span>
        </div>
    ) : null;
};

export default SellDate;
